"use client"
import { useState, useEffect } from "react"
import { useParams } from "react-router-dom"
import ProfessionalCard from "./ProfessionalCard"
import Pagination from "../pagination"
import { decryptId } from "../../utils/crypto";

export default function ProfessionalList({ screenshot }) {
  const { id } = useParams(); 
  const decryptedId = decryptId(id);
  const [professionalSummaries, setProfessionalSummaries] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const professionalsPerPage = 3;
const [professionalProjectTypesMap, setProfessionalProjectTypesMap] = useState({});

  const fetchProfessionalSummaries = async (projectId) => {
    try {
      const response = await fetch(`http://localhost:5000/project-professionals/${projectId}`);
      let data = await response.json();
      // Ensure data is always an array
      if (!Array.isArray(data)) {
        data = [];
      }
      setProfessionalSummaries(data);
    } catch (error) {
      console.error('Error fetching professional summaries:', error);
      setProfessionalSummaries([]); // fallback to empty array on error
    }
  };

  const fetchProfessionalProjectTypes = async (userId) => {
    try {
      const response = await fetch(`http://localhost:5000/professional-projects/${userId}`);
      const data = await response.json();
      return data.map(types => types.type);
          } catch (error) {
      console.error('Error fetching project details:', error);
return [];
    }
  };

  useEffect(() => {
    const fetchAllProjectTypes = async () => {
      const projectTypesMap = {};
      for (const professional of professionalSummaries) {
        if (professional.user_id) {
          projectTypesMap[professional.user_id] = await fetchProfessionalProjectTypes(professional.user_id);
        }
      }
      setProfessionalProjectTypesMap(projectTypesMap);
    };

    if (professionalSummaries.length > 0) {
      fetchAllProjectTypes();
    }
  }, [professionalSummaries]);

  useEffect(() => {
    if (decryptedId) {
      fetchProfessionalSummaries(decryptedId);
    }
  }, [decryptedId]);

  // Defensive: ensure professionalSummaries is always an array
  const professionalsArray = Array.isArray(professionalSummaries) ? professionalSummaries : [];
  const indexOfLastProfessional = currentPage * professionalsPerPage;
  const indexOfFirstProfessional = indexOfLastProfessional - professionalsPerPage;
  const currentProfessionals = professionalsArray.slice(indexOfFirstProfessional, indexOfLastProfessional);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <section>
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '20px' }}>
        <div style={{ width: '4px', height: '28px', borderRadius: '4px', background: 'linear-gradient(180deg, var(--accent-cyan), var(--accent-violet))' }} />
        <h2 style={{ fontSize: '1.3rem', fontWeight: 700, color: 'var(--text-primary)', fontFamily: 'var(--font-display)' }}>Professionals</h2>
      </div>
      <p style={{ marginBottom: '16px', color: 'var(--text-muted)', fontSize: '0.85rem' }}>
        Below is a list of professionals who map to your project requirements.
      </p>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {currentProfessionals.map((professional, index) => (
          professional.name != null && (
            <ProfessionalCard 
              key={index} 
              professional={professional} 
              professionalProjectTypes={professionalProjectTypesMap[professional.user_id] || []}
              isRecommended={professional.id === "2"}  
              screenshot={screenshot}
            />
          )
      ))}
      </div>
      <Pagination
        itemsPerPage={professionalsPerPage}
        totalItems={professionalsArray.length}
        paginate={paginate}
        currentPage={currentPage}
      />
    </section>
  );
}

